import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { loginUsers } from "../../api/users";

// ================= API CLIENT =================

// ================= PAGE LOGIN MOBILE =================
export function MobileLogin() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) {
      navigate("/mobile/upload");
    }
  }, []);

  const submitLogin = async () => {
    setLoading(true);
    // MODE TEST UI (sans API)
    // ---- À RÉACTIVER AVEC API ----
    setError(null);
    try {
      const res = await loginUsers(login, password);
      if (res.status === "success") {
        localStorage.setItem('user_id', res.data['id'])
        localStorage.setItem('token', res.token)
        localStorage.setItem('email', res.data['email'])
        localStorage.setItem('fonction_id', res.data['fonction_id'])
        localStorage.setItem('nom', res.data['nom'])
        localStorage.setItem('prenom', res.data['prenom'])
        navigate("/mobile/upload");
      }

    } catch (e) {
      setError("Login ou mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mobile-container">
      <div className="mobile-card login-page">
        <img src="/logo-cm.png" alt="Compagnie Masoandro" className="logo" />

        <h2 className="title">Connexion</h2>

        <input
          className="form-control mb-3"
          placeholder="Login"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
        />

        <input
          className="form-control mb-3"
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && (
          <div className="alert alert-danger text-center">
            {error}
          </div>
        )}
        <button
          className="btn btn-warning w-100"
          onClick={submitLogin}
          disabled={loading}
        >
          {loading ? "Connexion..." : "SE CONNECTER"}
        </button>
      </div>
    </div>
  );
}

